import { render, staticRenderFns } from "./shopping.vue?vue&type=template&id=6404e0f8&scoped=true&"
import script from "./shopping.vue?vue&type=script&lang=js&"
export * from "./shopping.vue?vue&type=script&lang=js&"
import style0 from "./shopping.vue?vue&type=style&index=0&id=6404e0f8&scoped=true&lang=scss&"
import style1 from "./shopping.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6404e0f8",
  null
  
)

export default component.exports